//
import { date, required } from '@/services/validations'
import UserModel from '@/models/General/GUser'
import DispatchRequestToListModel from '@/models/Warehouse/WhDispatchRequestToList'

//
import DispatchRequestFilters from '@/views/Warehouse/WhDispatchRequest/list/filters'
import DispatchRequestHeaders from '@/views/Warehouse/WhDispatchRequest/list/headers'

//
export default [
    {
        name: 'supervisor_g_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at_new',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'dispatch_date',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Despacho',
        },
    },
    {
        name: 'wh_selected_dispatch_request_batch_length',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'N° de solicitudes',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'zone',
        type: 'text-field',
        props: {
            label: 'Zona',
            rules: [required],
        },
    },
    {
        name: 'wh_selected_dispatch_request_batch',
        type: 'data-table-model',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestHeaders,
            noActions: true,
            noDataText: 'Sin solicitudes de despacho.',
            noExport: true,
            noFilter: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                attachParams: {
                    batch_id: '1'
                },
                filters: DispatchRequestFilters,
                headers: DispatchRequestHeaders,
                initialFilterValues: {
                    g_state_id: 24,
                },
                noDataText: 'Sin solicitudes de despacho.',
                noPagination: false,
                paramFilter: {
                    //g_state_id: [24].join(','), // solo solicitudes de abastecimiento confirmadas
                },
                rowsPerPage: 25,
                submitText: 'confirmar selección',
                service: DispatchRequestToListModel,
            },
            rules: [required],
            showNativePagination: true,
            showPicker: true,
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            toolbarTitle:
                'Lista de solicitudes de despacho incluidas en el lote',
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            noDataText: 'Sin empleados.',
            label: 'Descripción',
            rules: [required],
        },
    },
]
